<template>
  <span>{{ time }}</span>
</template>

<script>
export default {
  name: 'Timer',
  props: ['timer'],
  data () {
    return {
      time: '00:00:00',
      interval: null,
      end: null
    }
  },
  mounted () {
    if (this.timer) {
      this.calcTime()
      this.startTimer()
    } else {
      this.stopTimer()
    }
  },
  beforeDestroy () {
    this.stopTimer()
  },
  methods: {
    startTimer () {
      this.stopTimer()
      this.interval = setInterval(() => {
        this.calcTime()
      }, 1000)
    },
    stopTimer () {
      clearInterval(this.interval)
      this.end = new Date()
    },
    calcTime () {
      if (this.timer) {
        const now = new Date()
        const start = new Date(this.timer.created_at)
        // get total seconds between the times
        let delta = Math.abs(now - start) / 1000

        // calculate (and subtract) whole days
        const diffDays = Math.floor(delta / 86400)
        delta -= diffDays * 86400

        // calculate (and subtract) whole hours
        const diffHours = Math.floor(delta / 3600) % 24
        delta -= diffHours * 3600

        // calculate (and subtract) whole minutes
        const diffMinutes = Math.floor(delta / 60) % 60
        delta -= diffMinutes * 60

        // what's left is seconds
        const diffSeconds = Math.floor(delta % 60)

        this.time = String(diffHours).padStart(2, '0') + ':' + String(diffMinutes).padStart(2, '0') + ':' + String(diffSeconds).padStart(2, '0')
      } else {
        this.stopTimer()
      }
    }
  }
}
</script>
